import PageTitle from '@/components/PageTitle';
import { getPageTitle, PageSEO } from '@/components/SEO';
import siteMetadata from '@/data/siteMetadata';
import { getFileBySlug } from '@/lib/mdx';
import { getMDXComponent } from 'mdx-bundler/client';
import { useMemo } from 'react';

export async function getStaticProps({ params }) {
  const privacyPolicy = await getFileBySlug('legal', 'privacy-policy');

  return { props: { privacyPolicy } };
}

export default function PrivacyPolicy({ privacyPolicy }) {
  const { mdxSource, frontMatter } = privacyPolicy;

  const PrivacyPolicyMDX = useMemo(() => getMDXComponent(mdxSource), [mdxSource]);

  return (
    <div>
      <PageSEO title={getPageTitle('Privacy Policy')} description={siteMetadata.description} />
      <article>
        <div className="mb-6">
          <PageTitle>{frontMatter.title}</PageTitle>
        </div>
        <div className="prose w-full max-w-none">
          <PrivacyPolicyMDX />
        </div>
      </article>
    </div>
  );
}
